import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import { useForm } from "react-hook-form";
import useResidentesHook from "../../../api/residentes";

import useUserResidentesHook from "../../../api/user-residentes";
import usePermissionsHook from "../../../api/permissions";
import useClientPermissionsHook from "../../../api/clientPermissions";
import {
  Spinner,
  ViewResidentes,
  //   Pagination,
  FormResidentes,
  Message,
  Confirm,
} from "../../../components";

const Residentes = () => {
  const [page, setPage] = useState(1);
  const [id, setId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [q, setQ] = useState("");

  const { getResidentes, postResidente, updateResidente, deleteResidente } =
    useResidentesHook({
      page,
      q,
    });

  const { getPermissions } = usePermissionsHook({
    limit: 1000000,
  });
  const { getClientPermissions } = useClientPermissionsHook({
    limit: 1000000,
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const { data, isLoading, isError, error, refetch } = getResidentes;

  const { data: permissionData } = getPermissions;
  const { data: clientPermissionData } = getClientPermissions;

  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    error: errorUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateAsyncUpdate,
  } = updateResidente;

  const {
    isLoading: isLoadingDelete,
    isError: isErrorDelete,
    error: errorDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateAsyncDelete,
  } = deleteResidente;

  const {
    isLoading: isLoadingPost,
    isError: isErrorPost,
    error: errorPost,
    isSuccess: isSuccessPost,
    mutateAsync: mutateAsyncPost,
  } = postResidente;

  const formCleanHandler = () => {
    setEdit(false);
    reset();
  };

  useEffect(() => {
    if (isSuccessPost || isSuccessUpdate) formCleanHandler();
  }, [isSuccessPost, isSuccessUpdate]);

  useEffect(() => {
    refetch();
  }, [page]);

  useEffect(() => {
    if (!q) refetch();
  }, [q]);

  const searchHandler = (e) => {
    e.preventDefault();
    refetch();
    setPage(1);
  };

  const deleteHandler = (id) => {
    confirmAlert(Confirm(() => mutateAsyncDelete(id)));
  };

  const submitHandler = (data) => {
    edit
      ? mutateAsyncUpdate({
          _id: id,
          name: data.name,
          description: data.description,
          permission: data.permission,
          clientPermission: data.clientPermission,
        })
      : mutateAsyncPost(data);
  };

  const editHandler = (residente) => {
    setId(residente._id);
    setEdit(true);
    setValue("name", residente.nome);
    // setValue("description", role.description);
    // setValue(
    //   "permission",
    //   role.permission && role.permission.map((item) => item._id)
    // );
    // setValue(
    //   "clientPermission",
    //   role.clientPermission && role.clientPermission.map((item) => item._id)
    // );
    console.log(residente);
  };

  return (
    <>
      <Helmet>
        <title>Residentes</title>
        <meta property="og:title" content="Residentes" key="title" />
      </Helmet>
      {isSuccessDelete && (
        <Message variant="success">Residente removido com sucesso.</Message>
      )}
      {isErrorDelete && <Message variant="danger">{errorDelete}</Message>}
      {isSuccessUpdate && (
        <Message variant="success">Residente atualizado com sucesso.</Message>
      )}
      {isErrorUpdate && <Message variant="danger">{errorUpdate}</Message>}
      {isSuccessPost && (
        <Message variant="success">Residente adicionado com sucesso.</Message>
      )}
      {isErrorPost && <Message variant="danger">{errorPost}</Message>}

      <FormResidentes
        edit={edit}
        formCleanHandler={formCleanHandler}
        isLoading={isLoading}
        isError={isError}
        errors={errors}
        isLoadingUpdate={isLoadingUpdate}
        isLoadingPost={isLoadingPost}
        register={register}
        handleSubmit={handleSubmit}
        submitHandler={submitHandler}
        watch={watch}
        error={error}
        permissionData={permissionData && permissionData.data}
        clientPermissionData={clientPermissionData && clientPermissionData.data}
      />

      <div className="ms-auto text-end">
        {/* <Pagination data={data} setPage={setPage} /> */}
      </div>

      {isLoading ? (
        <Spinner />
      ) : isError ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <div className="tw-w-full">
          <>
            {!data ||
              (data.length < 1 && (
                <Message variant="info">Nenhum residente encontrado</Message>
              ))}

            <ViewResidentes
              data={data}
              useUserResidentesHook={useUserResidentesHook}
              editHandler={editHandler}
              deleteHandler={deleteHandler}
              isLoadingDelete={isLoadingDelete}
              setQ={setQ}
              q={q}
              searchHandler={searchHandler}
              //   deleteHandler={mutateAsyncDelete}
            />
          </>
        </div>
      )}
    </>
  );
};

export default Residentes;
